<template>
  
       <div class="result tc">
          <van-skeleton  :row="4" :loading="loading">
          <img :src="result.src" alt="">
          <h3>{{result.title}}</h3>
          <p class="fs12">{{result.desc}}</p>
          <div class="btns">
              <button @click="btnClick">{{result.btnsText}}</button>
              <!-- <a href="tel:17611127616">联系平台客服</a> -->
          </div>
            </van-skeleton>
      </div>

 
</template>

<script>
import {callApp} from '@/libs/bridge'
import { getBuyVip } from "@/api/plus";
import { POINT_CODE, BURY_POINT_TYPE,BEHAVIOR } from '@/libs/config'
import { buriedChannelPoint } from '@/api/common'
export default {
  name: 'plusResult',
  data() { 
    return {
        result:{
            src:'',
            title:'',
            desc:'',
            btnsText:''
        },
        detailType:1,
        orderNo:this.$basicsTools.getQueryUrl('outTradeNo'),
        time:0,
        loading:true,
        authenticationStatus:localStorage.getItem('authenticationStatus')
    }
  },
  created(){
    this.queryfrom()
  },
  mounted(){
    // this.goBack()
  },
  methods:{
    // // 返回首页
    // goBack(){
    //   callApp('redirectUrl',window.location.origin+'/#/services')
    // },
    // 循环查询订单
    queryfrom(){
      this.$toast.loading({
          message: '请稍等...',
          forbidClick: true,
          duration:0
     });

     let timer = setInterval(()=>{
         this.getqueryOrderPay()
         if(this.time > 4) clearInterval(timer)
         this.time ++ 
      },2000)

    },
    // 查询订单
    getqueryOrderPay(){
      console.log(this.orderNo);
      getBuyVip(this.orderNo).then(res=>{
        if( this.time > 2){
          this.loading = false;
           // 未支付
            this.result.src = res.data.status === 1000 ? require('@/assets/imgs/members/pay-fail.png') : require('@/assets/imgs/members/pay-success.png')
            this.result.title = res.data.status === 1000 ? '支付失败，请重新支付！' :'支付成功！'
            this.result.btnsText = res.data.status === 1000 ?  '重新支付': '返回'
            // this.result.desc = res.data.status === 1001 && this.authenticationStatus != 2 ? '您暂未认证，认证我们将开始向您推送案源':''
            this.result = {...this.result,...res.data}
            this.$toast.clear()
            // callApp('redirectUrl','empty')
            let params = JSON.parse(localStorage.getItem('SERVICESINFOS'))
            params.status = this.result.status

            let source = localStorage.getItem('source')
            params['source'] = source
            // 增值服务延长锁定次数支付成功页-整个页面曝光埋点
            let paramsCountPage = {
              code: POINT_CODE.LS_SDCS_ZFCG_PAGE,
              type: BURY_POINT_TYPE.PAGE,
              behavior: BEHAVIOR.VI,
            };
            // 支付成功且是锁定次数购买
            (params.status !== 1000 && params.type !== 'plus_number') && buriedChannelPoint(paramsCountPage);
            callApp('setOrderStatus',params)
        }
      })
    },
    btnClick(){
        let params = JSON.parse(localStorage.getItem('SERVICESINFOS'))
        let source = localStorage.getItem('source')
        params.status = this.result.status
        params['source'] = source
        if(this.result.status === 1000){
          // 支付失败
          this.$router.push({name:'plusFlow'})
        }else{
          // 支付成功
          this.$router.push({name:'plusVIP'})
        }
    }
  }
 }
</script>

<style lang="scss" scoped>
  .result{
      padding:40px 0;
      h3{
          margin-bottom: 16px;
          margin-top: 9px;
      }
      .btns{
          margin-top: 80px;
           button {
            width: 90%;
            line-height: 40px;
            background: #4A549E;
            color: #ffffff;
            font-size: 15px;
            outline: none;
            border: none;
            border-radius: 44px;
        }

        a{
            display: block;
            margin-top:16px;
            color: #4A549E;

        }
      }
  }
</style>